import { MembershipState } from "@/graphql/operations";

export const messagesRouteMeta = {
  hasNavbar: true,
  requiresWorkspace: false,
  displayLauncher: false,
} as const;

interface PotentialAdminTeam {
  myMembership?: {
    currentState?: MembershipState | null;
    mayAdministrate?: boolean | null;
  } | null;
}

export function isActiveAdminTeam<T extends PotentialAdminTeam>(
  team: T | null | undefined,
): team is T {
  return (
    team?.myMembership?.currentState === MembershipState.Active &&
    team.myMembership.mayAdministrate === true
  );
}

export function hasAnyActiveAdminTeam<T extends PotentialAdminTeam>(
  teams: readonly (T | null | undefined)[] | null | undefined,
): boolean {
  return teams?.some(isActiveAdminTeam) ?? false;
}
